import React from 'react'
import Field from 'components/AddOrEditFormPage/CustomForm/Field'
import Checkbox from 'components/AddOrEditFormPage/CustomForm/Checkbox'
// import FieldCheckbox from 'components/AddOrEditFormPage/CustomForm/FieldCheckbox'
import {
	ExpansionPanel,
	ExpansionPanelSummary,
	Typography,
	ExpansionPanelDetails,
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import MaxCharacters from './MaxCharacters'
import Warning from './Warning'

const text = ({ isEditing, isDragging, item }) => {
	return isEditing ? (
		<div style={{ padding: '20px 0' }}>
			<Field
				label="Question"
				property="label"
				statePath={(state) =>
					state.customForm.addOrEdit.sectionsByID[item.id].label
				}
				placeholder="Enter a question"
				sectionID={item.id}
			/>
			<Field
				label="Description"
				property="description"
				statePath={(state) =>
					state.customForm.addOrEdit.sectionsByID[item.id].description
				}
				placeholder="Enter a description"
				sectionID={item.id}
			/>
			<Checkbox
				label="Required"
				property="required"
				statePath={(state) =>
					state.customForm.addOrEdit.sectionsByID[item.id].field.required
				}
				type="field"
				sectionID={item.id}
			/>
			<ExpansionPanel>
				<ExpansionPanelSummary expandIcon={<ExpandMore />}>
					<Typography style={{ fontSize: 15 }}>Advanced</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails style={{ display: 'block' }}>
					<Checkbox
						label="Hidden"
						property="hidden"
						statePath={(state) =>
							state.customForm.addOrEdit.sectionsByID[item.id].field.hidden ||
							false
						}
						type="field"
						sectionID={item.id}
					/>
					<Checkbox
						label="Read only"
						property="readonly"
						statePath={(state) =>
							state.customForm.addOrEdit.sectionsByID[item.id].field.readonly ||
							false
						}
						type="field"
						sectionID={item.id}
					/>
					<Warning sectionID={item.id} />
					<MaxCharacters itemID={item.id} />
				</ExpansionPanelDetails>
			</ExpansionPanel>
		</div>
	) : (
		<>
			{item?.label && (
				<h3
					style={{
						marginBottom: 0,
						marginTop: '18.72px',
						fontSize: '18.72px',
						padding: 2,
					}}
				>
					{item.label || null}
					{item?.field?.required && <span style={{ color: 'red' }}>*</span>}
				</h3>
			)}
			{item?.description && (
				<div
					style={{
						marginBottom: 0,
						marginTop: '1.72px',
						fontSize: '12.72px',
						padding: 2,
					}}
				>
					{item.description}
				</div>
			)}
			<input
				className={item?.required ? 'vast_field reach_required' : 'vast_field'}
				type="text"
				name={item?.field?.field_name}
				datatype="text"
				style={{
					width: '100%',
					maxWidth: 500,
					border: '1px solid rgba(0, 0, 0, 0.1)',
					padding: 8,
					marginBottom: 8,
					marginTop: 0,
					borderRadius: 35,
				}}
			/>
		</>
	)
}

export default text
